import React from "react";
import ReactDOM from "react-dom";
import ScrollToTop from "./scrollToTop";
import App from "./App";

import * as serviceWorker from "./serviceWorker";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  withRouter,
} from "react-router-dom";
import { NavLink } from "react-router-dom";
import { Provider } from "react-redux";

import createStore from "./redux/createStore";

const store = createStore();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <ScrollToTop />
        <Switch>
          <Route path="/app" component={App} />
          <Route path="/" exact>
            <NavLink to="/app">
              {" "}
              <div>
                <img src="site.png" className="welcome-screen" />
              </div>
            </NavLink>
          </Route>
        </Switch>
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
